module.exports = __webpack_public_path__ + "media/images/landing/bg/screens-lafluencers/03-41ce2b9ec4b7f0fa9a3019e63929cfe8.png";